const actionTypes = {
  setAwsConfig: 'SET_AWS_CONFIG',
};

export default actionTypes;
